document.addEventListener("DOMContentLoaded", function () {
  const videoSection = document.querySelector(".full-screen-video");
  const headerHeading = document.querySelector(".header__heading");

  function toggleHeaderVisibility() {
    if (!videoSection || !headerHeading) return;
    const rect = videoSection.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

    if (isVisible) {
      headerHeading.style.visibility = "hidden";
    } else {
      headerHeading.style.visibility = "";
    }
  }

  window.addEventListener("scroll", toggleHeaderVisibility);
  window.addEventListener("resize", toggleHeaderVisibility);
  toggleHeaderVisibility();
});